import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../styles.css';
import { GOTO_PAGE, SHOW_LEADERS } from '../../HOME/REDUX/actions';
import BackIcon from '../../HOME/SVG/BackIcon';
import { hideLeaderboards } from '../../HOME/utils';
import { START_PAGE, GAME_PAGE, HIDE, HELP_PAGE, SKILL_PAGE, SIZE_PAGE, MODE_AI, MODE_SOLO } from '../../HOME/const';
import useGoHome from '../../HOME/useGoHome';
import { HIDE_PILE } from '../REDUX/actions';
import { CLUES_PAGE } from '../const';

const BackButton = () => {
  const dispatch = useDispatch();
  const goHome = useGoHome();
  const { singleApp, page, fromPage, showLeaders } = useSelector(state => state.common);
  const { mode, showPile } = useSelector(state => state.pt);

  if (singleApp && page === START_PAGE) {
    return null;
  }

  return (
    <div
      className="navigation-button"
      onClick={() => {
        switch (page) {
          case START_PAGE:
            goHome();
            return;
          case CLUES_PAGE:
          case SKILL_PAGE:
            dispatch({ type: GOTO_PAGE, payload: { page: START_PAGE } });
            return;
          case SIZE_PAGE:
            dispatch({ type: GOTO_PAGE, payload: { page: mode === MODE_AI ? SKILL_PAGE : CLUES_PAGE } });
            return;
          case HELP_PAGE:
            dispatch({ type: GOTO_PAGE, payload: { page: fromPage || START_PAGE } });
            return;
          case GAME_PAGE:
            if (showPile) {
              dispatch(HIDE_PILE);
            } else if (showLeaders === HIDE) {
              dispatch({ type: GOTO_PAGE, payload: { page: SIZE_PAGE } });
            } else {
              hideLeaderboards(op => dispatch({ type: SHOW_LEADERS, op }));
            }
            return;
          default:
            return;
        }
      }}>
      <BackIcon width="36" />
    </div>
  );
};

export default BackButton;
